import { useEffect, useState } from "react";
import Header from "/components/layout/Header";

import Footer from "/components/layout/Footer";
import PopUps from "/components/pop-ups/PopUp";
// import { ScrollBar } from "/utils/ScrollBarFactory";
import WalletPopUp from "/components/pop-ups/WalletPopUp";
import Home from "/views/Home";
import { useSoundHook } from "/utils/hooks/useSoundHook";
import { Outlet } from "react-router-dom";

export default function Layout({ state, auth }) {
  return (
    <>
      <Header {...{ state }} />
      <main>
        <Home state={state} />
      </main>
      <Outlet />
      <Footer />
      <PopUps state={state} />
      {auth?.token && auth?.pid && <WalletPopUp state={state} auth={auth} />}
    </>
  );
}
